import { Component, OnInit, inject, AfterViewInit, AfterContentInit } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable, map, shareReplay } from 'rxjs';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { MsalService } from '@azure/msal-angular';
import { ActivatedRoute, NavigationEnd, NavigationExtras, Router, UrlTree } from '@angular/router';
import { HttpGenericService } from 'src/app/shared/services/http-generic.service';
import { Roles } from 'src/app/shared/services/names.service';
import { AuthService } from 'src/app/modules/auth/services/auth.service';
import { DashboardService } from 'src/app/modules/dashboard/service/dashboard.service';
import { ChartsExportService } from 'src/app/modules/dashboard/service/charts-export/charts-export.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit, AfterContentInit {

  sidenavWidth = 60;
  classState = 'sidebar-collapsed';
  selectedLang: any;
  dashboardType: any;
  searchKeyWord!: string
  Roles = Roles
  activeDashboard = ""

  private breakpointObserver = inject(BreakpointObserver);
  loggedInUser: any;
  userRoles: unknown;

  constructor(public commonService: CommonService, private msalService: MsalService,
    public transService: TranslationService, private router: Router,
    private httpGenericService: HttpGenericService,
    private authService: AuthService,
    private exportService: ChartsExportService
  ) { }

  ngAfterContentInit(): void {
    setTimeout(() => {
      this.checkRoles()
    }, 500);
  }

  ngOnInit(): void {
    this.exportService.$isExporting.subscribe((value) => {
      if (value) {
        this.increase();
      } else {
        this.decrease();
      }
    })
    this.activeDashboard = localStorage.getItem("activeDashboard")
    this.dashboardType = this.activeDashboard
    const userString = localStorage.getItem('loggedinUser')
    this.loggedInUser = userString ? JSON.parse(userString) : null
    const lang = localStorage.getItem('language')
    this.selectedLang = lang ? lang : 'en'
    if (this.selectedLang === 'lang') {
      this.transService.setLanguage('en')
      localStorage.setItem('language', 'en')
      this.selectedLang = 'en'
    }
    else {
      this.transService.setLanguage(this.selectedLang)
      localStorage.setItem('language', this.selectedLang)
    }
    const direction = document.querySelector('html')
    if (this.selectedLang == 'ar') {
      direction!.setAttribute('dir', 'rtl')
    } else {
      direction!.setAttribute('dir', 'ltr')
    }
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (!this.router.url.includes('app/dashboard/search')) {
          this.searchKeyWord = ""
        }
      }
    });
  }

  async checkRoles() {
    this.userRoles = await this.authService.getUserRoles()
  }

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );

  increase() {
    this.sidenavWidth = 260;
    this.classState = 'sidebar-expended'
    this.tabsRtlPos();
    this.httpGenericService.sidebarState = true
  }

  decrease() {
    this.sidenavWidth = 60;
    this.classState = 'sidebar-collapsed'
    this.tabsRtlPos();
    this.httpGenericService.sidebarState = false
  }

  lan(value: string) {
    this.transService.setLanguage(value)
    this.selectedLang = value
    localStorage.setItem('language', value)
    window.location.reload()

    const direction = document.querySelector('html')
    if (this.selectedLang == 'ar') {
      direction!.setAttribute('dir', 'rtl')
    } else {
      direction!.setAttribute('dir', 'ltr')
    }
  }

  globalSearch(keyword: string) {
    this.searchKeyWord = keyword
    if (keyword)
      this.router.navigate(['/app/dashboard/search'], { queryParams: { keyword: this.searchKeyWord } });
  }

  dashboardChange(value: any) {
    this.activeDashboard = value
    if (value === Roles.eService) {
      location.href = `${environment.domain}/main.aspx?appid=${environment.appIdEservicesAndCaseManagement}&pagetype=dashboard&id=d201a642-6283-4f1d-81b7-da4b1685e698&type=system&_canOverride=true`
      return
    }
    //   else if(value === Roles.mktUser){
    // this.activeDashboard = value
    else if (value === Roles.mktUser) {
      this.router.navigate(['app/dashboard/mkt'])
    }
    else if (value === Roles.cprUser) {
      this.router.navigate(['/app/dashboard'])
    }
    else if (value === Roles.cmUser) {
      this.router.navigate(['/app/dashboard/cm'])
    }
    localStorage.setItem("activeDashboard", value)
  }

  logout() {
    this.msalService.logoutPopup({
      mainWindowRedirectUri: '/'
    }).subscribe((res: any) => {
      localStorage.clear()
    })
  }

  tabsRtlPos(): { left: number, top: number } | undefined {
    const direction = document.querySelector('html')?.getAttribute('dir');
    if (direction === 'rtl') {
      setTimeout(() => {
        const el = document.querySelector('.mat-tab-label-active .mat-tab-label-content');
        const rect = el?.getBoundingClientRect();
        if (rect) {
          const bar = document.querySelector('.mat-ink-bar') as HTMLElement;
          bar.style.left = `${rect.left + window.scrollX - 30}px`;
        }

      }, 500);
    }
    return undefined;
  }
}
